<template>
    <div class="main-content">
        <h1 v-translate>
            My Interactions
        </h1>
        <div class="main-content__my-leads">
            <div class="content-navigation">
                <ul class="content-navigation__container">
                    <li>
                        <router-link :to="{'name':'leads-list'}" class="content-navigation__link"
                                     :key="'leads-list'"
                                     exact-active-class="content-navigation__link--active"
                                     v-translate>Leads list
                        </router-link>
                    </li>
                    <li v-for="lead in lead_tabs" :key="lead.id">
                        <router-link :to="{'name':'lead-details', 'params': {'id':lead.id}}"
                                     class="content-navigation__link content-navigation__link--with-close-button"
                                     :key="'lead-details'"
                                     active-class="content-navigation__link--active"
                        >{{getLeadName(lead)}}
                        </router-link>
                        <div @click="closeTab(lead)" class="content-navigation__link-close"></div>
                    </li>
                </ul>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'Interactions',
        data() {
            return {
                tab_location: 'leads-list',
            }
        },
        computed: {
            ...mapState(['lead_tabs']),
        },
        methods: {
            ...mapActions(['removeLeadTab']),
            closeTab(lead) {
                this.removeLeadTab(lead)
                if (this.$router.currentRoute.params.id == lead.id) {
                    this.$router.push({name: 'leads-list'})
                }
            },
            getLeadName(lead) {
                if (lead.name) {
                    return lead.name
                }
                if (lead.email) {
                    return lead.email
                }
                return "Unknown lead"
            }
        }
    }
</script>